import { ProjectDto } from '@app/shared/models/contracts/project-dto';
import { cloneToMutableData } from '../clone/clone-to-mutable-data';

export const sortedProjectByCases = (project: ProjectDto): ProjectDto => {
  const clonedProject = cloneToMutableData(project);
  clonedProject.pwermInput.cases.sort((a, b) => a.caseOrder! - b.caseOrder!);
  return clonedProject;
};
